// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lightColorTypo {
  color: var(--color-typo-primary);
}

.snackbar {
  position: absolute;
  bottom: var(--size-text-2xs);
  right: 0;
}

::-webkit-scrollbar {
  width: 6px;
  background-color: none;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--color-bg-brand);
}

::-webkit-scrollbar-track {
  background-color: none;
}

.Text:not(.Text_view_alert, .Text_view_warning, .Text_view_normal) {
  color: var(--color-typo-primary);
}

.MixScrollBar::-webkit-scrollbar {
  width: 6px;
  background-color: none;
}

.MixScrollBar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--color-bg-brand);
}

.MixScrollBar::-webkit-scrollbar-track {
  background-color: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,4BAAA;EACA,QAAA;AACJ;;AAEA;EACI,UAAA;EACA,sBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,uCAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAGA;EACI,UAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,uCAAA;AAAJ;;AAGA;EACI,sBAAA;AAAJ","sourcesContent":[".lightColorTypo {\n    color: var(--color-typo-primary);\n}\n\n.snackbar {\n    position: absolute;\n    bottom: var(--size-text-2xs);\n    right: 0;\n}\n\n::-webkit-scrollbar {\n    width: 6px;\n    background-color: none;\n}\n\n::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background-color: var(--color-bg-brand);\n}\n\n::-webkit-scrollbar-track {\n    background-color: none;\n}\n\n.Text:not(.Text_view_alert, .Text_view_warning, .Text_view_normal) {\n    color: var(--color-typo-primary)\n}\n\n\n.MixScrollBar::-webkit-scrollbar {\n    width: 6px;\n    background-color: none;\n}\n\n.MixScrollBar::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background-color: var(--color-bg-brand);\n}\n\n.MixScrollBar::-webkit-scrollbar-track {\n    background-color: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
